import { GitBranch, Terminal } from 'lucide-react';

import Omni from '@/assets/ico/vendor/omni.svg?c';
import { usePublicSettings } from '@/react/portainer/settings/queries';

import { BoxSelector, BoxSelectorOption } from '@@/BoxSelector';

import { CredentialType } from '../types';

type Props = {
  value: CredentialType;
  onChange: (credentialType: CredentialType) => void;
};

const providerOptions: BoxSelectorOption<CredentialType>[] = [
  {
    id: CredentialType.OMNI,
    icon: Omni,
    label: 'Sidero Omni',
    description: 'Sidero Omni Kubernetes management platform',
    value: CredentialType.OMNI,
    iconType: 'logo',
  },
  {
    id: CredentialType.SSH,
    icon: Terminal,
    iconType: 'badge',
    label: 'SSH',
    description: 'Connect to your machines over SSH',
    value: CredentialType.SSH,
  },
  {
    id: CredentialType.GIT,
    icon: GitBranch,
    iconType: 'badge',
    label: 'Git',
    description: 'Git repository access credentials for shared use',
    value: CredentialType.GIT,
  },
];

export function CloudProviderSelector({ value, onChange }: Props) {
  const { data: publicSettings } = usePublicSettings();
  const isFIPSMode = !!publicSettings?.FIPSMode;

  // Create dynamic options with cloud providers disabled when FIPS mode is
  // enabled (SSH and Git aren't cloud provisioning credentials, so they remain available)
  const dynamicProviderOptions = providerOptions.map((option) => {
    if (option.id !== CredentialType.SSH && option.id !== CredentialType.GIT) {
      return {
        ...option,
        disabled: () => isFIPSMode,
        tooltip: () =>
          isFIPSMode ? 'FIPS mode restricts access to cloud providers' : '',
      };
    }
    return option;
  });

  return (
    <BoxSelector
      radioName="cloudProvider"
      options={dynamicProviderOptions}
      value={value}
      onChange={onChange}
    />
  );
}
